import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Text from '@zg-rentals/multibrand-ui/lib/Text';


import PageHeroAutocomplete from 'app/shared/components/PageHero/PageHeroAutocomplete';

import './style.scss';

/**
 * PageHeroContainer can be used to display a full bleed hero
 * on a landing page
 * Note: Pass className to PageHeroContainer and set background-img URL via CSS
 *
 */

const propTypes = {
    hasGradient: PropTypes.bool,
};

const defaultProps = {
    hasGradient: false,
};

const PageHeroContainer = (props) => {
    const {
        className, hasGradient, addressList,
    } = props;

    return (
        <Container
            className={cx('PageHeroContainer', className, {
                'PageHeroContainer-gradient': hasGradient,
            })}
            fluid={true}
        >
            <Text type="h1" className="PageHeroContainer-title stacked-sm">
                How Much Should I Charge For Rent?
            </Text>
            <PageHeroAutocomplete
                addressList={addressList}
            />
        </Container>
    );
};

PageHeroContainer.propTypes = propTypes;
PageHeroContainer.defaultProps = defaultProps;

export default PageHeroContainer;
